import { FunctionComponent } from "react";
import { clsx } from "clsx";

import styles from "./ToggleButtons.module.scss";

type IncomingType = {
    array: number[] | string[];
    selectIndex: number;
    setSelect: (newIndex: number) => void;
};

export const ToggleButtons: FunctionComponent<IncomingType> = ({ array, selectIndex, setSelect }) => {

    return (
        <div className={styles.container}>
            {array.map((element, index) => <div key={element} onClick={() => setSelect(index)} className={clsx(styles.btn, selectIndex === index && styles.active)}>{element}</div>)}
        </div>
    )
}